import React, { useState, useEffect } from 'react';
import Aux from '../../hoc/Aux';
import { axiosPublic } from '../../axios-wizard';
import { URLS } from '../../urls';
import LogoDescriptionTable from '../Shared/LogoDescriptionTable'

const LogoDescriptionProductSystem = (props) => {

  const logos = props.logos;

  const sealsList = (logos) => {
    return logos.sort( (a,b) => parseInt(a.position) - parseInt(b.position));
  }

  return (
    <LogoDescriptionTable logos={sealsList(logos)} />
  )
};

export default LogoDescriptionProductSystem;



// WEBPACK FOOTER //
// ./src/components/Shared/LogoDescriptionProductSystem.js